<template>
  <GoogleAdsPopup
    path="/22777916944/RTBGo_Web_PopUp_Banner_640x480"
    :size="[640, 480]"
    id="div-gpt-ad-1744098047778-0"
    style="margin:0 auto;"
  />
</template>

<script>
import GoogleAdsPopup from "../../../popup/googleAdsPopup.vue";
export default {
  data() {
    return {};
  },
  components: {
    GoogleAdsPopup,
  },
};
</script>

<style scoped></style>
